export default __webpack_public_path__ + "static/media/EricThumb400.838db40c.jpg";